import React from 'react';
import MaterialTable from 'material-table';
import {pasillosResources} from "../endpoints";
import SnackbarAlert from "./SnackbarAlert";
import tableicons from "../tableicons"
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CreateIcon from '@material-ui/icons/Create';
import Check from '@material-ui/icons/Check'
import DialogAgregarEditarPasillo from './DialogAgregarEditarPasillo';
import DialogAgregarEditarMetro from './DialogAgregarEditarMetro';
import DialogEliminar from './DialogEliminar';

class TablaMetroPasillo extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            datos: [],
            openDialogPasillo:false,
            openDialogMetro:false,
            idPadre: null,
            title: "",
            pasillo:null,
            metro:null,
            idPasillo: 0,
            idMetro: 0,
            eliminarPasillo: false,
            eliminarMetro: false,
            openSnack:false,
            severity: null,
            message:null,
            selectedRow: null,
            seleccionados:[],
            eliminarMultiplesMetros: false,
            idMetrosSeleccionados: []
        }
    };

    refrescarDatos =(estado,severity) =>{
        this.setState({openDialogMetro: false, openDialogPasillo: false, pasillo: null, metro: null, eliminarPasillo:false, eliminarMetro: false, openSnack:false, severity: null, message:null,selectedRow: null,eliminarMultiplesMetros: false,
        idMetrosSeleccionados: [], 
        seleccionados: [],});
        if(severity === "success"){
            this.obtenerDatos()
        }
        this.setState({openSnack:true, severity:severity, message:estado})
    }

    obtenerDatos = () => {
        this.setState({ cargando: true, openSnack: false, severity: null, message: null });
    
        // Selecciona la función a llamar en base a `tipo`
        let obtenerFuncion = null;
        if (this.props.tipo === 'todos') {
            obtenerFuncion = pasillosResources.obtenerPasillos;
        } else {
            obtenerFuncion = pasillosResources.obtenerPasillosAuditados;
        }
    
        if (obtenerFuncion) {
            obtenerFuncion()
                .then(async (response) => {
                    if (response) {
                        return await response.json();
                    }
                })
                .then((result) => {
                    if (result.status_code === 200) {
                        this.setState({ datos: result.pasillos, cargando: false });
                    } else if (result.status_code === 401) {
                        this.setState({ openSnack: true, severity: result.severity, message: result.message, cargando: false });
                    } else {
                        this.setState({ cargando: false });
                        throw new Error('Something went wrong ...');
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        cargando: false,
                        openSnack: true,
                        severity: 'error',
                        message: 'Ha ocurrido un error al obtener los datos',
                    });
                });
        } else {
            this.setState({
                cargando: false,
                openSnack: true,
                severity: 'error',
                message: 'Tipo de datos no reconocido',
            });
        }
    };
    

    handleClose = () => {
        this.setState({openDialogPasillo: false, openDialogMetro: false, eliminarMetro: false, eliminarPasillo: false, eliminarMultiplesMetros:false});
    };

    editarPasillo (row){
        this.setState({openDialogPasillo: true, idPadre:null, title: "Editar pasillo", accion: 'editar', pasillo:row, openSnack:false})
    };

    editarMetro (row){
        this.setState({openDialogMetro: true, idPadre:row.padre, title: "Editar metro", accion: 'editar', metro:row, openSnack:false})
    };

    agregarMetro (id){
        this.setState({openDialogMetro: true, idPadre:id, title: "Agregar metro", accion: 'agregar', openSnack:false})
    };

    eliminarPasillo(row){
        this.setState({eliminarPasillo:true, idPasillo:row.id.match(/\d+/)[0], title: "Eliminar Pasillo", content: "Esta acción es irreversible. Está seguro que desea eliminar el pasillo?. Tenga en cuenta que se eliminarán los metros asociados al pasillo", openSnack:false})
    }

    eliminarMetro(row){
        this.setState({eliminarMetro:true, idMetro:row.id.match(/\d+/)[0], title: "Eliminar Metro", content: "Esta acción es irreversible. Está seguro que desea eliminar el metro?", openSnack:false})
    }

    UNSAFE_componentWillMount() {
        this.obtenerDatos()
     }

    componentDidUpdate(prevProps) {
        // Verifica si `tipo` cambió
        if (prevProps.tipo !== this.props.tipo) {
            this.obtenerDatos(); // Vuelve a ejecutar la función obtenerDatos
        }
    }

    eliminarMetrosSeleccionados = () => {
        // Nos aseguramos de filtrar solo filas hijas (metros) por si acaso
        const metrosFiltrados = this.state.seleccionados.filter(row => row.padre !== null);
        
        if (metrosFiltrados.length === 0) return;

        // Extraemos los IDs numéricos limpios del string (ej: "metro_45" -> "45")
        const idsMetros = metrosFiltrados.map(row => row.id.match(/\d+/)[0]);

        this.setState({
            eliminarMultiplesMetros: true, // <--- Activa el nuevo diálogo
            idMetrosSeleccionados: idsMetros,
            title: "Eliminar Metros Seleccionados",
            content: `¿Está seguro que desea eliminar los ${idsMetros.length} metros seleccionados? Esta acción es irreversible.`,
            openSnack: false
        });
    }

    render() {
        return (
            <div>
                <style>{`
                    thead th.MuiTableCell-paddingCheckbox,
                    thead th span.MuiButtonBase-root.MuiCheckbox-root {
                        display: none !important;
                        visibility: hidden !important;
                        opacity: 0 !important;
                        pointer-events: none !important;
                    }
                `}</style>
                <MaterialTable
                    isLoading={this.state.cargando}
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                            nRowsSelected: "{0} fila(s) seleccionado(s)"
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense",
                        selection: true,
                        selectionProps: rowData => ({
                            // Opcional: Deshabilita el checkbox si es un Pasillo (padre) 
                            // para obligar a que solo seleccionen Metros.
                            disabled: rowData.padre === null, 
                            color: 'primary'
                        }),
                    }}
                    icons={tableicons}
                    title=" Pasillos y metros "
                    data={this.state.datos}
                    columns={[
                        { title: 'Área', field: 'area', render: rowData => rowData.padre == null ?  rowData.area : '',
                            cellStyle: {
                                width: 500,
                                maxWidth: 500,
                            },
                            headerStyle: {
                                width: 500,
                                maxWidth: 500
                            }},
                        { title: 'Pasillo', field: 'numero',
                            cellStyle: {
                                width: 500,
                                maxWidth: 500,
                            },
                            headerStyle: {
                                width: 500,
                                maxWidth: 500
                            }},
                        { title: 'Descripción Pasillo', field: 'nombre',
                            cellStyle: {
                                width: 500,
                                maxWidth: 500,
                            },
                            headerStyle: {
                                width: 500,
                                maxWidth: 500
                            }},
                        { title: 'Metro', field: 'nombre_metro',
                            cellStyle: {
                                width: 500,
                                maxWidth: 500,
                            },
                            headerStyle: {
                                width: 500,
                                maxWidth: 500
                            }},
                        { title: 'Auditando', field: 'para_auditar', render: rowData => rowData.padre == null ?  (rowData.para_auditar? <Check style={{fontSize:27, margin:4}}></Check> : '') : '',

                            cellStyle: {
                                width: 500,
                                maxWidth: 500,
                            },
                            headerStyle: {
                                width: 500,
                                maxWidth: 500
                            }},
                        {
                            title: 'Acciones',
                            field: 'id',
                            cellStyle: { width: 250, maxWidth: 250, textAlign: 'right' },
                            headerStyle: { width: 250, maxWidth: 250, textAlign: 'right' },
                            render: rowData => (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                    
                                    {/* BOTÓN AGREGAR: Solo se renderiza si es Pasillo (padre === null) */}
                                    {rowData.padre == null && (
                                        <button 
                                            onClick={(e) => { e.stopPropagation(); this.agregarMetro(rowData.id); }}
                                            title="Agregar metro"
                                            style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#3f51b5' }}
                                        >
                                            <AddCircleIcon style={{ fontSize: 27 }} />
                                        </button>
                                    )}

                                    {/* BOTÓN EDITAR: Sirve para ambos, pasillo o metro */}
                                    <button 
                                        onClick={(e) => { 
                                            e.stopPropagation(); 
                                            rowData.padre == null ? this.editarPasillo(rowData) : this.editarMetro(rowData); 
                                        }}
                                        title="Editar"
                                        style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#3f51b5' }}
                                    >
                                        <CreateIcon style={{ fontSize: 27 }} />
                                    </button>

                                    {/* BOTÓN ELIMINAR: Sirve para ambos, pasillo o metro */}
                                    <button 
                                        onClick={(e) => { 
                                            e.stopPropagation(); 
                                            rowData.padre == null ? this.eliminarPasillo(rowData) : this.eliminarMetro(rowData); 
                                        }}
                                        title="Eliminar"
                                        style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#d32f2f' }}
                                    >
                                        <DeleteIcon style={{ fontSize: 27 }} />
                                    </button>
                                </div>
                            )
                        }
                    ]}
                    actions={[
                        () => {
                            // Validamos si hay metros seleccionados en el estado
                            if (this.state.seleccionados.length === 0) return null;

                            return {
                                icon: () => <DeleteIcon style={{ fontSize: 27, color: '#e41818' }} />,
                                tooltip: 'Eliminar metros seleccionados',
                                isFreeAction: true, // Hace que aparezca arriba en el Toolbar general
                                onClick: () => this.eliminarMetrosSeleccionados()
                            };
                        }
                    ]}
                                        parentChildData={(row, rows) => rows.find(a => a.id === row.padre)}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    onSelectionChange={(rows) => this.setState({seleccionados:rows})}
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.openDialogPasillo? <DialogAgregarEditarPasillo accion={this.state.accion} title={this.state.title} refrescar={this.refrescarDatos} pasillo={this.state.pasillo} padre={null} handleClose={this.handleClose}/> : null}
                {this.state.openDialogMetro? <DialogAgregarEditarMetro accion={this.state.accion} title={this.state.title} refrescar={this.refrescarDatos} metro={this.state.metro} pasillo={this.state.datos.find(pasillo => pasillo.id === this.state.idPadre)} datos={this.state.datos} handleClose={this.handleClose}/> : null}
                {this.state.eliminarPasillo? <DialogEliminar origen={"Pasillo"} handleClose={this.handleClose} refrescar={this.refrescarDatos} content={this.state.content} title={this.state.title} id={this.state.idPasillo}/>:null}
                {this.state.eliminarMetro? <DialogEliminar origen={"Metro"} handleClose={this.handleClose} refrescar={this.refrescarDatos} content={this.state.content} title={this.state.title} id={this.state.idMetro}/>:null}
                {this.state.eliminarMultiplesMetros ? 
                    <DialogEliminar 
                        origen={"MetrosMultiples"} 
                        handleClose={this.handleClose} 
                        refrescar={this.refrescarDatos} 
                        content={this.state.content} 
                        title={this.state.title} 
                        id={this.state.idMetrosSeleccionados} // Pasa el arreglo de IDs completos
                    /> : null
                }

            </div>
        )
    }
}
export default TablaMetroPasillo;